export default "__VITE_ASSET__957ab122__"